var map = {
	"./GoCater.png": "de33",
	"./Labelleassiette.png": "933f",
	"./Makeleaps.png": "871d",
	"./adyen bw.png": "9462",
	"./adyen.png": "6dc1",
	"./amplified.png": "2afc",
	"./azarus.png": "ec10",
	"./bionluk.png": "c5bc",
	"./bitpay.png": "320f",
	"./curvegrid.png": "3c42",
	"./enterra bw.jpg": "c784",
	"./enterra.jpg": "3f72",
	"./entouch.png": "e1f6",
	"./everyst.png": "1522",
	"./kabutoyohou.png": "5580",
	"./kraken bw.png": "aa6c",
	"./kraken.png": "f978",
	"./legolas.png": "99e7",
	"./supervaisor.png": "403c",
	"./swan.png": "459b",
	"./telcoin.png": "97db",
	"./ubuntoo.png": "b370",
	"./zaiko.png": "520a",
	"./zaisan.png": "2a6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb36";